import { getCookie } from '../../services/Cookie';
import parseJSONSGracefully from '../../services/parseJSONSGracefully';
import { post } from '../../services/request';
import CookieNames from '../../constants/CookieNames';

const KEEP_ALIVE_REQUEST_PENDING = 'keepAliveRequestPending';

export function getExpirationTimestampFromCookie() {
    const cookie = getCookie(CookieNames.SESSION_EXPIRATION_TIMESTAMP);
    const timestamp = parseJSONSGracefully(cookie);
    return timestamp;
}

export function getSecondsBeforeSessionExpires(expireTime) {
    return (expireTime - Date.now()) / 1000;
}

export async function postSessionKeepAlive() {
    const response = await post('/ui/session/keep-alive');
    return response;
}

export function keepAliveRequestIsPending() {
    return localStorage.getItem(KEEP_ALIVE_REQUEST_PENDING) === 'true';
}

export function setKeepAliveRequestPending() {
    localStorage.setItem(KEEP_ALIVE_REQUEST_PENDING, 'true');
}

export function clearKeepAliveRequestPending() {
    localStorage.removeItem(KEEP_ALIVE_REQUEST_PENDING);
}
